import * as styles from "./KnobValue.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { useKnobContext } from "./Knob.context";
import type { KnobValueProps } from "./Knob.types";

export function KnobValue({
  className,
  children,
}: KnobValueProps): JSX.Element {
  const { value, boxSize } = useKnobContext();

  return (
    <span
      data-slot="knob-value"
      className={clsx(styles.value, className)}
      style={{ fontSize: `calc(${boxSize} * 0.18)` }}
    >
      {children ? children(value) : value}
    </span>
  );
}
